import { useContext } from "react"
import { Navigate } from "react-router-dom"
import { CurrentGroupContext } from "source/groups/my/groups"

export default function RedirectToChatDrawer() {
  const group = useContext(CurrentGroupContext)
  const chatEnabled = group.abilities.conversations.can_read
  const chatGroupGraphId = `Groups-Group-${group.id}`
  const chatDrawerFragment = `#chat=/?filter=${chatGroupGraphId}`

  if (!chatEnabled) return <Navigate to={group.base_path} replace />

  // We must reload the browser for Chat to notice the fragment and open the drawer
  window.location.replace(`${group.base_path}${chatDrawerFragment}`)
}
